import * as routes from 'api/routes';
import { SliderItem } from 'api/main_page/public/get/params';

export type Item = SliderItem;
export type Params = { search?: string };
export type Result = Item[];

export const ROUTE = routes.W_MANDATES_GET;
